import * as React from 'react';
import { observer } from 'mobx-react';
import { FormState, FieldState } from 'formstate';

// Utilities
import { required } from '../../utilities/validation';

// FormState
class PasswordForm {
    password = new FieldState('').disableAutoValidation().validators(required);

    state = new FormState({
        username: this.password
    });

    gerValues() {
        return {
            username: this.password.$
        };
    }
}

// Components
import Box from '../../components/Box';
import { Form, TextField } from '../../components/FormStateFields';
import Typography from '../../components/Typography';

// Component
interface IProps {
    form: PasswordForm;
    onSubmit: () => void;
}

class PasswordStep extends React.Component<IProps, {}> {
    handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        this.props.onSubmit();
    }

    render() {
        return (
            <Box pa={4}>
                <Typography type="headline">Joining private network</Typography>
                <Typography type="subheading" color="textSecondary">
                    Please enter the access-key to proceed.
                </Typography>
                <Form onSubmit={this.handleSubmit}>
                    <TextField
                        label="Access-key"
                        type="password"
                        fieldState={this.props.form.password}
                        margin="normal"
                        fullWidth={true}
                        autoFocus={true}
                    />
                    <button
                        style={{ opacity: 0, position: 'absolute' }}
                        type="submit"
                    />
                </Form>
            </Box>
        );
    }
}

export { PasswordForm };
export default observer(PasswordStep);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/NetworksDialogJoinPassword.tsx